export default __webpack_public_path__ + "static/media/greenBig.f7f26add.svg";